<template>
  <div class="hbanner">
    <div class="swiper-container advSwiper">
      <div class="swiper-wrapper">
       


        <div class="swiper-slide" v-for="(val, key) in bannerList" :key="key">
          <div class="hbacon">
            <img
              v-if="val.type == 1"
              :src="val.ext"
              class="banner_tit ani animated"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration=".3s"
              swiper-animate-delay="0.3s"
            />
            <img :src="val.pic" class="bann_pic" />
            <div
              v-if="val.type == 1"
              class="hbmore ani animated"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration=".5s"
              swiper-animate-delay="0.3s"
            >
              <span class="moBtn moBtn1" @click="toDemo(val.url)"
                >了解更多</span
              >
              <span class="zxBtn zxBtn1" @click="toConsultation()"
                >购车咨询</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination swiper-pagination1"></div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min.js";

export default {
  data() {
    return {
      mySwiper2: null,
      bannerList: [],
      swiper: "",
      fileUrl: require("@/assets/image/bannerv1.mp4"),
      videoPlayIsFirstTime: 1,
      videoPaused: false
    };
  },
  created() {},

  mounted() {
    let that = this;
    this.$post("/api/banner", {
      platform: "pc"
    }).then(resp => {
      if (resp.code == 1) {
        this.bannerList = resp.data;
        this.$nextTick(() => {
          this.initSwiper();

          //let wow = new WOW({
          // live: false,
          //})
          //wow.init()
          var video = this.$refs.videoPlayer2;
          video.addEventListener("play", () => {
            console.log("监听视频开始播放11");
            //console.log(this.mySwiper)
            this.mySwiper.autoplay.stop();
            this.videoPaused = video.paused
            this.videoPlayIsFirstTime++
          });
          video.addEventListener("ended", () => {
            console.log("监听视频结束播放");
            this.mySwiper.slideNext();
            this.mySwiper.autoplay.start();
            this.mySwiper.update();
            this.videoPaused = video.paused
          });
        });
      }
    });
  },
  methods: {
    initSwiper() {
      let that = this;
      if (this.swiper != "") {
        return;
      }
      this.mySwiper = new Swiper(".advSwiper", {
        observer: true,
        observeParents: true,
        speed: 500,
        slidesPerView: "auto",
        centeredSlides: true,
        autoplay: {
          disableOnInteraction: false
        },
        loop: false,

        pagination: {
          el: ".swiper-pagination1",
          clickable: true
        },
        on: {
          init: function() {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionEnd: function() {
            swiperAnimate(this);
          },
          slideChange: function() {
            if (this.activeIndex == 0 && this.videoPlayIsFirstTime === 1) {
              that.toPlay();
            } else {
              that.toPause();
            }
          }
        }
      });
    },
    toDemo(url) {
      if (url.length > 0) {
        window.location.href = url;
      } else {
        this.$router.push({
          name: "demo",
          query: {}
        });
      }
    },
    //  视频播放
    toPlay() {
      this.vedFlag = false;
      this.$refs.videoPlayer2.play();
      console.log("kaishi");
      this.videoPaused = this.$refs.videoPlayer2.paused
      // this.$refs.videoPlayer.paused === true
      //   ? this.$refs.videoPlayer.play()
      //   : this.$refs.videoPlayer.pause()
    },
    toPause() {
      this.$refs.videoPlayer2.pause();
      this.videoPaused = this.$refs.videoPlayer2.paused
      this.mySwiper.autoplay.start();
      this.mySwiper.update();
    },
    toConsultation() {
      this.$router.push({
        name: "consultation",
        query: {}
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/home/banner.vue